import { render, staticRenderFns } from "./HealthLog.vue?vue&type=template&id=354441d0&scoped=true&"
import script from "./HealthLog.vue?vue&type=script&lang=js&"
export * from "./HealthLog.vue?vue&type=script&lang=js&"
import style0 from "./HealthLog.vue?vue&type=style&index=0&id=354441d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354441d0",
  null
  
)

export default component.exports